import algoliasearch from 'algoliasearch/lite'
import getWithInMemoryCache from '../../utils/getWithInMemoryCache'
import globals from '../../utils/globals'
import {Component} from 'preact'

const SEARCH_TOKEN_URL = '/search/searchToken'

export async function getIndex () {
  const data: {client_id: string, token: string} = await getWithInMemoryCache(SEARCH_TOKEN_URL, {})
  const client = algoliasearch(data.client_id, data.token)
  return client.initIndex(globals('communityId'))
}

export default abstract class<P = {}, S = {}> extends Component<P, S> {
  algoliaIndex: algoliasearch.Index

  async componentDidMount () {
    this.algoliaIndex = await getIndex()
  }
}
